<template>
  <section class="companypass">
    <div class="companypass__content container">
      <div class="companypass__content--header">
        <h2 class="companypass__title">
          Secure your spot<br><b>Today</b>
        </h2>
        <img src="../assets/isotype.svg" alt="SEQUIRE Summit Isotype">
      </div>
      <hr class="half-line --full" />
      <p class="companypass__description">
        Limited seats available. Register now to join this exclusive gathering
        of investors, innovators, and industry leaders shaping the future of business.
      </p>
      <div class="companypass__points">
        <div class="companypass__points--box" v-for="point in points" :key="point.id">
          <h3>{{ point.title }}</h3>
          <p> {{ point.description }}</p>
        </div>
      </div>
      <div class="companypass__buttons">
        <a href="https://forms.monday.com/forms/5ab96b8f289480d9d3479556bcc057e0?r=use1" target="_blank">
          <button class="btn-new">
            Get Conference Pass
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        </a>
        <a href="https://buy.stripe.com/4gM8wOclm2yk27l2la3cc0V" target="_blank">
          <button class="btn-new-alt">
            Get Presenter Pass
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        </a>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: 'Company Pass',
  data() {
    return {
      points: [
        { title: 'Full access',
          description: 'to all keynotes and panel discussions',
        },
        { title: 'VIP Networking',
          description: '1:1 sessions with speakers',
        },
        { title: 'Exclusive',
          description: 'investor-only meetups',
        },
        { title: 'Premium',
          description: 'event materials and resources',
        },
        { title: 'Access',
          description: 'to post-event investment opportunities',
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/components/companypass.scss";
</style>